module.exports = "https://web-assets-production.autolist.com/_next/static/images/heat-map-demo-a923483ee4388ec21801eb3918a5a80d.png";